<script setup>
import { onMounted, ref, watch, nextTick, onBeforeUnmount } from 'vue';
import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';
import BreezeNavLink from '@/Components/NavLink.vue';
import BreezeResponsiveNavLink from '@/Components/ResponsiveNavLink.vue';
import { Inertia } from '@inertiajs/inertia';
import { Link, useForm, usePage } from '@inertiajs/inertia-vue3';
//import { useLayoutStore } from "@/stores/layout.js";
import { useStyleStore } from "@/stores/style.js";
import BaseIcon from "@/Components/BaseIcon.vue";
import { mdiThemeLightDark, mdiWhiteBalanceSunny, mdiBell, mdiMoonWaningCrescent, mdiUmbrellaBeach, mdiStar, mdiStarShooting } from "@mdi/js";
import CardBoxModal from "@/Components/CardBoxModal.vue";
import CardBoxModalPopup from "@/Components/CardBoxModalPopup.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeSelect from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import UnensAlert from "@/Components/UnensAlert.vue";
import { Icon } from '@iconify/vue'

const page = usePage();
const showOnboarding = ref(false);
const currentStep = ref(1);

const onboardingSteps = [
    {
        title: "¡Bienvenido a tu nuevo panel!",
        content: "Hemos diseñado una interfaz más moderna, limpia y rápida. Permítenos mostrarte cómo interactuar con el menú lateral.",
        targetId: "desktop-sidebar",
        position: "right"
    },
    {
        title: "Maximiza tu espacio de trabajo",
        content: "Si necesitas más espacio para tus contenidos, haz clic en este botón de la barra superior para contraer el menú lateral. Haz clic nuevamente para expandirlo.",
        targetId: "sidebar-toggle-btn",
        position: "bottom-left"
    },
    {
        title: "Navegación al instante",
        content: "Desde el menú lateral tienes acceso a todas las secciones (Inicio, Aulas, Cursos, etc.) y puedes configurar marcadores rápidos para las páginas que usas frecuentemente.",
        targetId: "desktop-sidebar-nav",
        position: "right"
    }
];

const spotlightStyle = ref({
    top: '0px',
    left: '0px',
    width: '0px',
    height: '0px',
    opacity: 0
});

const tooltipStyle = ref({
    top: '0px',
    left: '0px',
    opacity: 0
});

const updateSpotlight = () => {
    if (!showOnboarding.value) return;

    if (window.innerWidth < 1024) {
        spotlightStyle.value = { opacity: 0 };
        tooltipStyle.value = {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            opacity: 1,
            zIndex: 100,
            width: '320px'
        };
        return;
    }

    const step = onboardingSteps[currentStep.value - 1];
    const el = document.getElementById(step.targetId);
    if (el) {
        const rect = el.getBoundingClientRect();
        const padding = 6;
        spotlightStyle.value = {
            top: `${rect.top - padding}px`,
            left: `${rect.left - padding}px`,
            width: `${rect.width + padding * 2}px`,
            height: `${rect.height + padding * 2}px`,
            opacity: 1,
            position: 'fixed',
            zIndex: 99,
            pointerEvents: 'none',
            boxShadow: '0 0 0 9999px rgba(15, 23, 42, 0.75)',
            borderRadius: '12px',
            transition: 'all 0.3s ease-in-out'
        };

        let top = 0;
        let left = 0;

        if (step.position === 'right') {
            top = rect.top + rect.height / 2 - 100;
            left = rect.right + 20;
        } else if (step.position === 'bottom-left') {
            top = rect.bottom + 20;
            left = rect.left - 150;
        }

        if (left < 10) left = 10;
        if (left + 350 > window.innerWidth) left = window.innerWidth - 370;
        if (top < 10) top = 10;
        if (top + 250 > window.innerHeight) top = window.innerHeight - 270;

        tooltipStyle.value = {
            position: 'fixed',
            top: `${top}px`,
            left: `${left}px`,
            opacity: 1,
            zIndex: 100,
            transition: 'all 0.3s ease-in-out',
            width: '350px'
        };
    } else {
        spotlightStyle.value = { opacity: 0 };
        tooltipStyle.value = {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            opacity: 1,
            zIndex: 100,
            width: '350px'
        };
    }
};

const nextStep = () => {
    if (currentStep.value < onboardingSteps.length) {
        currentStep.value++;
    } else {
        finishOnboarding();
    }
};

const prevStep = () => {
    if (currentStep.value > 1) {
        currentStep.value--;
    }
};

const finishOnboarding = () => {
    showOnboarding.value = false;
    axios.post(route('user-onboarding'))
        .then(response => {
            if (page.props.value.auth.user) {
                page.props.value.auth.user.estado_onboarding = false;
            }
        })
        .catch(error => {
            console.error('Error al guardar estado de onboarding:', error);
        });
};

watch([currentStep, showOnboarding], () => {
    nextTick(() => {
        updateSpotlight();
    });
});

onBeforeUnmount(() => {
    window.removeEventListener('resize', updateSpotlight);
    document.removeEventListener('fullscreenchange', handleFullscreenChange);
});

onMounted(() => {
    countAlerts()
    listarMark()
    document.addEventListener('fullscreenchange', handleFullscreenChange);

    if (page.props.value.auth.user && page.props.value.auth.user.estado_onboarding) {
        // Wait briefly for page rendering to complete before calculating positions
        setTimeout(() => {
            showOnboarding.value = true;
            window.addEventListener('resize', updateSpotlight);
        }, 1000);
    }
});

const alerts = ref(0);
const freedayPdte = ref(0);

const countAlerts = () => {
    countFreeday()
    countFacture()
    //alerts.value = freedayPdte.value;
}

const countFreeday = () => {
    let url = '/freeday/getcountdata';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        freedayPdte.value = respuesta.freedaypdte
        //console.log('Días libres pendientes de aprob.: ' + freedayPdte.value);
    }).catch(function (error) {
        //console.log(error);
    });
}

const countFacture = () => {
    let url = '/facture/getcountdata';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        alerts.value = respuesta.facturepdte
        //console.log('DTE PDTE: ' + alerts.value);
    }).catch(function (error) {
        //console.log(error);
    });
}

const arrayMarks = ref([])
const listarMark = () => {
    let url = '/mark/global';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayMarks.value = respuesta.data;
    }).catch(function (error) {
        console.log(error);
    });
}

const showingNavigationDropdown = ref(false);
const styleStore = useStyleStore();
const isRrhhExpanded = ref(route().current('freeday*') || route().current('collaborator*'));
const isFinancieraExpanded = ref(route().current('areaFinanciera*') || route().current('financiera*') || route().current('payementOrder*') || route().current('facture*'));
const isSidebarCollapsed = ref(typeof localStorage !== 'undefined' ? localStorage.getItem('sidebar-collapsed') === 'true' : false);
const toggleSidebar = () => {
    isSidebarCollapsed.value = !isSidebarCollapsed.value;
    if (typeof localStorage !== 'undefined') {
        localStorage.setItem('sidebar-collapsed', isSidebarCollapsed.value.toString());
    }
};

const isFullscreen = ref(false);
const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen().catch(err => {
            console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
        });
    } else {
        document.exitFullscreen();
    }
};
const handleFullscreenChange = () => {
    isFullscreen.value = !!document.fullscreenElement;
};

//const layoutStore = useLayoutStore();

// Menú varias opciones pero sólo seusará darklight
const menuClick = (event, item) => {
    if (item.isToggleLightDark) {
        styleStore.setDarkMode();
    }

    if (item.isLogout) {
        //
    }
};

const setDarkMode = () => {
    styleStore.setDarkMode();
}

// Modal
const modulo = ref('mark')
const isModalActive = ref(false);
const isErrorForm = ref(false)
const rowID = ref(0);
const rowAction = ref('action');
const form = useForm({
    ref: '',
    label: '',
    secondary_label: '',
    label_short: null,
    short_label: null,
    parent: null,
    position: 0,
    anio: '',
    anio_fin: '',
    asunto: '',
    type: '',
    description: '',
    name: '',
    visible: 0,
    admin: 0,
    value: '',
    entity: 0,
    transkey: '',
    transvalue: '',
    day: '01',
    month: '01',
    year: 0,
    url: '' + window.location.href + '',
    redirect: route().current(),
    target: 0, // <-- Sin target directo esta página
    color: 'red'

});

const initModal = (id, action, data = []) => {
    isErrorForm.value = false
    rowAction.value = action

    if (action == 'registrar') {
        isModalActive.value = true
        if (modulo.value == 'mark') {
            rowAction.value = 'registrar-own'
        }

    } else if (action == 'actualizar') {
        rowID.value = id;
        isModalActive.value = true
        form.label = data['label']// <-- Todos tienen label
        if (props.isRef) form.ref = data['ref']

        if (modulo.value == 'mark') {
            form.label = data['label']
            form.description = data['description']
            form.url = data['url']
            form.target = data['target']
            form.color = data['color']
            form.position = data['position']
        }

    }
}
const isConfirm = () => {
    //alert('Hola '+rowID.value+'modal es '+rowAction.value)
    const ruta = modulo.value + '-' + rowAction.value
    /*axios.put(ruta, {
      'id' : rowID.value
    }).then(function response () {
      // Escribir algo si es ok
      //window.location.reload()
      //Redirect(props.ruta)
      //redirect('config-distrito')
      //return route('config-distrito');
  
      //Inertia.get(route('config-distrito'))
    }).catch(function (error) {
      //console.log(error)
    })*/
    if (rowAction.value == 'registrar-own') {

        if (modulo.value == 'mark') { // <-- table simple
            if (!form.label) {
                isModalActive.value = true
                isErrorForm.value = true
            } else {
                let url = '/config/mark/registrarown'
                axios.post(url, {
                    'label': form.label,
                    'description': form.description,
                    'url': form.url,
                    'target': form.target,
                    'color': form.color,
                    'position': form.position
                }).then(function response() {
                    cleanVal()
                }).catch(function (error) {
                    //console.log(error)
                })
            }

        }

    } else if (rowAction.value == 'actualizar') {

        if (modulo.value == 'mark') { // Tabla simple
            if (!form.label || !form.url) {
                isModalActive.value = true
                isErrorForm.value = true
            } else {
                Inertia.put(route(ruta, {
                    'id': rowID.value,
                    'label': form.label,
                    'description': form.description,
                    'url': form.url,
                    'target': form.target,
                    'color': form.color,
                    'position': form.position
                }
                ))
                cleanVal()
            }

        }

    } else {
        // Activar, desactivar o eliminar
        if (modulo.value == 'mark') {
            Inertia.put(route(ruta, {
                'id': rowID.value,
                //'search_criterio': selectCriterio.value,
                //'search_buscar': buscarCriterio.value
            }
            ))
            cleanVal()
        }


    }

}

const isCancel = () => {
    cleanVal()
}

const cleanVal = () => {

    //form.type = ''
    isErrorForm.value = false
    form.label = ''
    form.description = ''
    form.note = ''
    form.position = 0
    form.name = ''
    // Level entity
    form.entity = 1
    form.url = window.location.href
    form.target = 0
    form.color = 'red'

}

</script>

<template>
    <!-- Vista previa Modal -->
    <CardBoxModal v-model="isModalActive" title="Crear Marcador Actual" hasCancel @confirm="isConfirm" @cancel="isCancel"><!-- tien el botón de cancelar superior-->
        <form>
            <template v-if="modulo == 'mark'">
                <div>
                    <BreezeLabel for="label" value="Nombre" :required="true" />
                    <BreezeInput id="label" type="text" class="mt-1 block w-full input-premium" v-model="form.label" required autocomplete="label" />
                </div>
                <div>
                    <BreezeLabel for="description" value="Descripción (opcional)" />
                    <textarea id="description" class="input-premium mt-1 block w-full" v-model="form.description" autocomplete="description" />
                </div>
                <div :class="(form.target ? '' : 'invisible')">
                    <BreezeLabel for="url" value="URL (ejemplo: https://unens.com)" :required="true" />
                    <BreezeInput id="url" type="text" class="mt-1 block w-full input-premium" v-model="(form.url)" required autocomplete="off" :readOnly="(form.target ? false : true)" />
                </div>
                <div>
                    <BreezeLabel for="color" value="Color" /> <button :class="'bg-' + form.color + '-500'" type="button"> ___ </button>
                    <select v-model="form.color" required class="input-premium mt-1 block w-full">
                        <option value="red">Rojo</option>
                        <option value="blue">Azul</option>
                        <option value="sky">Celeste</option>
                        <option value="emerald">Esmeralda</option>
                        <option value="green">Verde</option>
                        <option value="lime">Lima</option>
                        <option value="yellow">Amarillo</option>
                        <option value="slate">Gris</option>
                        <option value="purple">Púrpura</option>
                    </select>
                </div>
                <div>
                    <BreezeLabel for="position" value="Posición" />
                    <BreezeInput id="position" type="number" class="mt-1 block w-full input-premium" v-model="form.position" required autocomplete="position" />
                </div>
            </template>

        </form>
    </CardBoxModal>

    <div :class="{
        dark: styleStore.darkMode,
    }">
        <div class="min-h-screen bg-slate-50 dark:bg-slate-900 text-slate-800 dark:text-slate-100 flex flex-col lg:flex-row">

            <!-- DESKTOP SIDEBAR (lg:flex, hidden on smaller screens) -->
            <aside id="desktop-sidebar" class="hidden lg:flex flex-col shrink-0 bg-white dark:bg-slate-800 border-r border-slate-200 dark:border-slate-700 h-screen sticky top-0 transition-all duration-300 ease-in-out" :class="isSidebarCollapsed ? 'w-20' : 'w-72'">
                <!-- Logo & Sede Header -->
                <div class="h-20 px-6 border-b border-slate-200 dark:border-slate-700 flex items-center justify-start shrink-0">
                    <div class="flex items-center gap-3 w-full">
                        <BreezeApplicationLogo class="h-14 w-auto shrink-0" />
                        <div v-show="!isSidebarCollapsed" class="flex flex-col overflow-hidden">
                            <span class="text-[10px] text-slate-400 font-medium leading-none mb-0.5">Sede</span>
                            <h3 class="text-slate-900 dark:text-white text-sm font-bold truncate w-full" :title="confGlobal.value.UNENS_SEDE_NOMBRE">
                                {{ confGlobal.value.UNENS_SEDE_NOMBRE }}
                            </h3>
                        </div>
                    </div>
                </div>
                <!-- Sidebar Navigation Menu -->
                <nav id="desktop-sidebar-nav" class="flex-1 overflow-y-auto p-4 space-y-1.5 custom-scrollbar">
                    <!-- Inicio / Dashboard -->
                    <Link :href="route('dashboard')" :title="isSidebarCollapsed ? 'Inicio' : ''" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('dashboard*')
                        ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                        : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                        <Icon icon="tabler:smart-home" class="w-5 h-5 shrink-0" />
                        <span v-show="!isSidebarCollapsed">Inicio</span>
                    </Link>

                    <!-- ========================================================================= -->
                    <!-- VISTA EXCLUSIVA: PORTAL DE ESTUDIANTES Y APODERADOS (Roles 8 y 9)         -->
                    <!-- Rutas y accesos optimizados para alumnos matriculados y sus apoderados    -->
                    <!-- ========================================================================= -->
                    <template v-if="$page.props.auth.user.id_rol == 8 || $page.props.auth.user.id_rol == 9">
                        <!-- Cursos del Aula Regular -->
                        <Link v-if="$page.props.auth.user.has_classroom" :href="route('student-courses')" :title="isSidebarCollapsed ? 'Cursos' : ''" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('student-courses*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:book-2" class="w-5 h-5 shrink-0" />
                            <span v-show="!isSidebarCollapsed">Cursos</span>
                        </Link>

                        <!-- Cursos de Formación Estudiante -->
                        <Link v-if="$page.props.auth.user.has_independent_courses" :href="route('student.independent-courses')" :title="isSidebarCollapsed ? 'Cursos de Formación' : ''" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('student.independent-courses*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:certificate" class="w-5 h-5 shrink-0" />
                            <span v-show="!isSidebarCollapsed">Cursos de Formación</span>
                        </Link>

                        <!-- Agenda del Estudiante -->
                        <Link :href="route('student-agenda')" :title="isSidebarCollapsed ? 'Agenda' : ''" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('student-agenda*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:calendar" class="w-5 h-5 shrink-0" />
                            <span v-show="!isSidebarCollapsed">Agenda</span>
                        </Link>
                    </template>

                    <!-- ========================================================================= -->
                    <!-- VISTA DE COLABORADORES Y ADMINISTRATIVOS (Gestión basada en Rights)       -->
                    <!-- ========================================================================= -->
                    <template v-else>
                        <!-- Aulas -->
                        <Link v-if="hasRight('global', 'classroom') || $page.props.auth.user.id_rol <= 6 || $page.props.auth.user.id_rol == 7 || $page.props.auth.user.id_rol == 11 || $page.props.auth.user.id_rol == 12" :href="route('classrooms-collaborator')" :title="isSidebarCollapsed ? 'Aulas' : ''" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('classroom*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:chalkboard" class="w-5 h-5 shrink-0" />
                            <span v-show="!isSidebarCollapsed">Aulas</span>
                        </Link>

                        <!-- Cursos de Formación (Colaboradores) -->
                        <Link v-if="hasRight('global', 'formationcourses') && hasRight('cursolibre', 'read')" :href="route('independent-courses.index')" :title="isSidebarCollapsed ? 'Cursos de Formación' : ''" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('independent-courses.index*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:certificate" class="w-5 h-5 shrink-0" />
                            <span v-show="!isSidebarCollapsed">Cursos de Formación</span>
                        </Link>

                        <!-- Estudiantes -->
                        <Link v-if="hasRight('global', 'students') || $page.props.auth.user.id_rol <= 6" :href="route('student-list')" :title="isSidebarCollapsed ? 'Estudiantes' : ''" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('student-*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:users" class="w-5 h-5 shrink-0" />
                            <span v-show="!isSidebarCollapsed">Estudiantes</span>
                        </Link>

                        <!-- Financiera (Desplegable) -->
                        <div v-if="hasRight('global', 'financial')" class="space-y-1">
                            <button @click="isSidebarCollapsed ? toggleSidebar() : isFinancieraExpanded = !isFinancieraExpanded" :title="isSidebarCollapsed ? 'Financiera' : ''" class="w-full flex items-center justify-between px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="(route().current('areaFinanciera*') || route().current('financiera*') || route().current('payementOrder*') || route().current('facture*'))
                                ? 'bg-slate-100 dark:bg-slate-700/70 text-slate-900 dark:text-white font-semibold'
                                : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                                <div class="flex items-center gap-3">
                                    <Icon icon="tabler:wallet" class="w-5 h-5 shrink-0" />
                                    <span v-show="!isSidebarCollapsed">Financiera</span>
                                </div>
                                <Icon v-show="!isSidebarCollapsed" :icon="isFinancieraExpanded ? 'tabler:chevron-down' : 'tabler:chevron-right'" class="w-4 h-4 shrink-0 transition-transform" />
                            </button>

                            <div v-show="isFinancieraExpanded && !isSidebarCollapsed" class="pl-6 space-y-1 border-l border-slate-100 dark:border-slate-700 ml-6 mt-1">
                                <Link v-if="hasRight('finanzas', 'read_regular')" :href="route('areaFinanciera')" class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200" :class="route().current('areaFinanciera*') || route().current('payementOrder*') || route().current('facture*')
                                    ? 'text-indigo-600 dark:text-indigo-400 font-semibold'
                                    : 'text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'">
                                    <Icon icon="tabler:school" class="w-4 h-4 shrink-0" />
                                    <span>Ciclo Escolar Regular</span>
                                </Link>

                                <Link v-if="hasRight('finanzas', 'read_formacion') || hasRight('finanzas', 'orders_read')" :href="route('financiera-formacion.index')" class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200" :class="route().current('financiera-formacion*')
                                    ? 'text-indigo-600 dark:text-indigo-400 font-semibold'
                                    : 'text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'">
                                    <Icon icon="tabler:certificate" class="w-4 h-4 shrink-0" />
                                    <span>Cursos de Formación</span>
                                </Link>
                            </div>
                        </div>

                        <!-- RRHH (Desplegable) -->
                        <div v-if="hasRight('global', 'rrhh') || hasRight('asistencia', 'marcaciones') || $page.props.auth.user.id_rol <= 6" class="space-y-1">
                            <button @click="isSidebarCollapsed ? toggleSidebar() : isRrhhExpanded = !isRrhhExpanded" :title="isSidebarCollapsed ? 'RRHH' : ''" class="w-full flex items-center justify-between px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="(route().current('freeday*') || route().current('collaborator*'))
                                ? 'bg-slate-100 dark:bg-slate-700/70 text-slate-900 dark:text-white font-semibold'
                                : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                                <div class="flex items-center gap-3">
                                    <Icon icon="tabler:users-group" class="w-5 h-5 shrink-0" />
                                    <span v-show="!isSidebarCollapsed">RRHH</span>
                                </div>
                                <Icon v-show="!isSidebarCollapsed" :icon="isRrhhExpanded ? 'tabler:chevron-down' : 'tabler:chevron-right'" class="w-4 h-4 shrink-0 transition-transform" />
                            </button>

                            <div v-show="isRrhhExpanded && !isSidebarCollapsed" class="pl-6 space-y-1 border-l border-slate-100 dark:border-slate-700 ml-6 mt-1">
                                <Link :href="route('collaborator-list')" class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200" :class="route().current('collaborator-list*')
                                    ? 'text-indigo-600 dark:text-indigo-400 font-semibold'
                                    : 'text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'">
                                    <Icon icon="tabler:user-check" class="w-4 h-4 shrink-0" />
                                    <span>Colaboradores</span>
                                </Link>

                                <Link :href="route('freeday-list')" class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200" :class="route().current('freeday-list*')
                                    ? 'text-indigo-600 dark:text-indigo-400 font-semibold'
                                    : 'text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'">
                                    <Icon icon="tabler:beach" class="w-4 h-4 shrink-0" />
                                    <span>Días Libres</span>
                                </Link>

                                <Link v-if="hasRight('global', 'rrhh') || hasRight('asistencia', 'marcaciones') || $page.props.auth.user.id_rol <= 3" :href="route('collaborator-registroasistencia')" class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200" :class="route().current('collaborator-registroasistencia*')
                                    ? 'text-indigo-600 dark:text-indigo-400 font-semibold'
                                    : 'text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'">
                                    <Icon icon="tabler:clock" class="w-4 h-4 shrink-0" />
                                    <span>Asistencias</span>
                                </Link>
                            </div>
                        </div>

                        <!-- Productos -->
                        <Link v-if="confGlobal.value.PRODUCT_USE_MODULE == 1 && ($page.props.auth.user.id_rol <= 6 || hasRight('global', 'configuration'))" :href="route('product-list')" :title="isSidebarCollapsed ? 'Productos' : ''" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('product-*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:package" class="w-5 h-5 shrink-0" />
                            <span v-show="!isSidebarCollapsed">Productos</span>
                        </Link>

                        <!-- Agenda Colaboradores -->
                        <Link v-if="hasRight('global', 'agenda') && ($page.props.auth.user.id_rol != 8 && $page.props.auth.user.id_rol != 9)" :href="route('agenda')" :title="isSidebarCollapsed ? 'Agenda' : ''" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('agenda*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:calendar-event" class="w-5 h-5 shrink-0" />
                            <span v-show="!isSidebarCollapsed">Agenda</span>
                        </Link>

                        <!-- Documentos -->
                        <Link v-if="hasRight('global', 'documents') || $page.props.auth.user.id_rol <= 5 || $page.props.auth.user.id_rol == 7 || $page.props.auth.user.id_rol == 10 || $page.props.auth.user.id_rol == 11" :href="route('documents')" :title="isSidebarCollapsed ? 'Documentos' : ''" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('documents*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:files" class="w-5 h-5 shrink-0" />
                            <span v-show="!isSidebarCollapsed">Documentos</span>
                        </Link>

                        <!-- Simulacro examen de admisión -->
                        <Link v-if="hasRight('global', 'simulacroexamen') && hasRight('simulacro', 'read') && confGlobal.value.ACADEMICO_USE_SIMULACRO_ADMISION == 1" :href="route('examenadmision')" :title="isSidebarCollapsed ? 'Examen Admision' : ''" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('examenadmision*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:certificate" class="w-5 h-5 shrink-0" />
                            <span v-show="!isSidebarCollapsed">Simulacro examen de admisión</span>
                        </Link>

                        <!-- Comunicados -->
                        <Link v-if="hasRight('global', 'comunicados') || $page.props.auth.user.id_rol <= 3" :href="route('comunicados-list')" :title="isSidebarCollapsed ? 'Comunicados' : ''" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('comunicados*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:speakerphone" class="w-5 h-5 shrink-0" />
                            <span v-show="!isSidebarCollapsed">Comunicados</span>
                        </Link>

                        <!-- Reportes -->
                        <Link v-if="hasRight('global', 'reports')" :href="route('report')" :title="isSidebarCollapsed ? 'Reportes' : ''" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('report*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:chart-bar" class="w-5 h-5 shrink-0" />
                            <span v-show="!isSidebarCollapsed">Reportes</span>
                        </Link>

                        <!-- Configuración -->
                        <Link v-if="hasRight('global', 'configuration')" :href="route('config')" :title="isSidebarCollapsed ? 'Configuración' : ''" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('config*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:settings" class="w-5 h-5 shrink-0" />
                            <span v-show="!isSidebarCollapsed">Configuración</span>
                        </Link>
                    </template>
                </nav>

                <!-- Sidebar Footer (User Card) -->
                <div class="border-t border-slate-100 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/30" :class="isSidebarCollapsed ? 'p-2' : 'p-4'">
                    <BreezeDropdown align="top-left" width="48" class="w-full">
                        <template #trigger>
                            <button class="w-full flex items-center gap-2 p-2 rounded-xl hover:bg-slate-200/50 dark:hover:bg-slate-700/50 transition-colors" :class="isSidebarCollapsed ? 'justify-center' : 'justify-between'">
                                <div class="flex items-center gap-3 overflow-hidden">
                                    <div class="w-10 h-10 rounded-full bg-indigo-500 text-white flex items-center justify-center font-bold text-sm shrink-0 uppercase" :title="isSidebarCollapsed ? $page.props.auth.user.name : ''">
                                        {{ $page.props.auth.user.name.substring(0, 2) }}
                                    </div>
                                    <div v-show="!isSidebarCollapsed" class="overflow-hidden text-left">
                                        <h5 class="text-sm font-semibold text-slate-800 dark:text-white truncate uppercase">{{ $page.props.auth.user.name }}</h5>
                                        <span class="text-xs text-slate-400 dark:text-slate-500 block truncate">Rol: {{ $page.props.auth.user.rol_type }}</span>
                                    </div>
                                </div>
                                <Icon v-show="!isSidebarCollapsed" icon="tabler:dots-vertical" class="w-5 h-5 text-slate-500 dark:text-slate-400" />
                            </button>
                        </template>
                        <template #content>
                            <BreezeDropdownLink :href="route('perfil')" as="button">
                                <span class="flex items-center gap-2">
                                    <Icon icon="tabler:user" class="w-4 h-4" />
                                    Mi Perfil
                                </span>
                            </BreezeDropdownLink>
                            <BreezeDropdownLink :href="route('help')" method="get" as="button">
                                <span class="flex items-center gap-2">
                                    <Icon icon="tabler:help" class="w-4 h-4" />
                                    Ayuda {{ confGlobal.value.UNENSEDU_VERSION }}
                                </span>
                            </BreezeDropdownLink>
                            <BreezeDropdownLink :href="route('logout')" method="post" as="button">
                                <span class="flex items-center gap-2 text-rose-600">
                                    <Icon icon="tabler:logout" class="w-4 h-4" />
                                    Salir
                                </span>
                            </BreezeDropdownLink>
                        </template>
                    </BreezeDropdown>
                </div>
            </aside>

            <!-- MAIN WRAPPER (TOP BAR + HEADER + MAIN CONTENT) -->
            <div class="flex-1 flex flex-col min-w-0">

                <!-- TOP HEADER BAR -->
                <header class="bg-white/80 dark:bg-slate-800/80 backdrop-blur-md border-b border-slate-200 dark:border-slate-700 h-20 flex items-center justify-between px-6 sticky top-0 z-40">

                    <!-- MOBILE HEADER / SIDEBAR TOGGLE -->
                    <div class="flex items-center gap-2 sm:gap-3 lg:hidden">
                        <button @click="showingNavigationDropdown = !showingNavigationDropdown" class="p-2 rounded-lg text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors">
                            <Icon icon="tabler:menu-2" class="w-6 h-6" />
                        </button>
                        <BreezeApplicationLogo class="h-10 w-auto shrink-0" />
                        <h4 class="hidden sm:block text-slate-900 dark:text-white text-md font-bold truncate max-w-[120px]">
                            {{ confGlobal.value.UNENS_SEDE_NOMBRE }}
                        </h4>
                    </div>

                    <!-- DESKTOP BREADCRUMB / STATUS (hidden on mobile) -->
                    <div class="hidden lg:flex items-center gap-3">
                        <button @click="toggleSidebar" id="sidebar-toggle-btn" class="p-2 rounded-xl text-slate-500 hover:text-indigo-600 dark:text-slate-400 dark:hover:text-indigo-400 hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-all mr-2" title="Alternar Menú Lateral">
                            <Icon :icon="isSidebarCollapsed ? 'tabler:layout-sidebar-left-expand' : 'tabler:layout-sidebar-left-collapse'" class="w-6 h-6" />
                        </button>
                        <button @click="toggleFullscreen" id="maximizeworkarea-btn" class="p-2 rounded-xl text-slate-500 hover:text-indigo-600 dark:text-slate-400 dark:hover:text-indigo-400 hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-all mr-2" :title="isFullscreen ? 'Restaurar Área de Trabajo' : 'Maximizar Área de Trabajo'">
                            <Icon :icon="isFullscreen ? 'tabler:minimize' : 'tabler:maximize'" class="w-6 h-6" />
                        </button>
                        <span class="text-sm font-semibold text-slate-500 dark:text-slate-400 flex items-center gap-1.5">
                            <Icon icon="tabler:school" class="w-4 h-4 text-indigo-500" />
                            Portal Académico
                        </span>
                    </div>

                    <!-- ALERTS, BOOKMARKS, LOGOUT (RIGHT CONTAINER) -->
                    <div class="flex items-center gap-1 sm:gap-3">
                        
                        <!-- Bookmarks -->
                        <BreezeDropdown align="right" class="">
                            <template #trigger>
                                <button class="p-2 rounded-xl text-slate-500 hover:text-amber-500 dark:text-slate-400 dark:hover:text-amber-400 hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-all flex items-center justify-center" title="Marcadores">
                                    <BaseIcon :path="mdiStar" :size="20" />
                                </button>
                            </template>
                            <template #content>
                                <div class="p-2 font-bold text-xs text-slate-400 uppercase border-b border-slate-100 dark:border-slate-700 mb-1 px-4">
                                    Marcadores rápidos
                                </div>
                                <button @click="initModal('', 'registrar')" class="w-full text-left px-4 py-2 text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors flex items-center gap-2">
                                    <Icon icon="tabler:plus" class="w-4 h-4 text-slate-400" />
                                    Agregar página actual
                                </button>
                                <BreezeDropdownLink :href="route('config-mark')" as="button">
                                    <span class="flex items-center gap-2">
                                        <Icon icon="tabler:list" class="w-4 h-4 text-slate-400" />
                                        Listar marcadores
                                    </span>
                                </BreezeDropdownLink>
                                <template v-if="arrayMarks.length" v-for="obj in arrayMarks" :key="obj.id">
                                    <a v-if="obj.target" :href="obj.url" target="_blank" class="w-full text-left px-4 py-2 text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors flex items-center gap-2">
                                        <BaseIcon :path="mdiStarShooting" :size="16" class="text-amber-400" />
                                        <span class="truncate">{{ obj.label }}</span>
                                    </a>
                                    <BreezeDropdownLink v-else :href="obj.url" as="button">
                                        <span class="flex items-center gap-2">
                                            <BaseIcon :path="mdiStar" :size="16" class="text-amber-400 shrink-0" />
                                            <span class="truncate">{{ obj.label }}</span>
                                        </span>
                                    </BreezeDropdownLink>
                                </template>
                            </template>
                        </BreezeDropdown>

                        <!-- Pending Vacation/Free Days Alert -->
                        <a v-if="freedayPdte > 0 && $page.props.auth.user.id_rol <= 6" title="Días libres por aprobar" href="#" class="p-2 rounded-xl text-rose-500 dark:text-rose-400 hover:bg-rose-50 dark:hover:bg-rose-950/20 transition-all flex items-center gap-1 ">
                            <BaseIcon :path="mdiUmbrellaBeach" :size="20" />
                            <span class="text-xs font-bold bg-red-500 text-white rounded-full px-1.5 py-0.5 min-w-[18px] text-center scale-90">
                                {{ freedayPdte }}
                            </span>
                        </a>

                        <!-- System Alerts (DTE/Factures Pending) -->
                        <BreezeDropdown v-if="alerts > 0 && $page.props.auth.user.id_rol <= 6" align="right" width="64" class="">
                            <template #trigger>
                                <button class="p-2 rounded-xl text-red-500 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-950/20 transition-all flex items-center gap-1">
                                    <BaseIcon :path="mdiBell" :size="20" />
                                    <span class="text-xs font-bold bg-red-500 text-white rounded-full px-1.5 py-0.5 min-w-[18px] text-center scale-90">
                                        {{ alerts }}
                                    </span>
                                </button>
                            </template>
                            <template #content>
                                <div class="p-4 text-sm text-slate-600 dark:text-slate-300">
                                    <p class="font-semibold text-slate-800 dark:text-white flex items-center gap-2 mb-1">
                                        <Icon icon="tabler:alert-triangle" class="text-rose-500 w-5 h-5 shrink-0" />
                                        Notificaciones
                                    </p>
                                    Comprobantes pendientes de envío: <span class="font-bold text-rose-600 dark:text-rose-400">{{ alerts }}</span>
                                </div>
                            </template>
                        </BreezeDropdown>

                        <!-- Dark / Light Theme Toggle -->
                        <button @click="setDarkMode()" class="p-2 rounded-xl text-slate-500 hover:text-indigo-600 dark:text-slate-400 dark:hover:text-indigo-400 hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-all flex items-center justify-center" title="Alternar Modo Oscuro">
                            <BaseIcon :path="(styleStore.darkMode ? mdiMoonWaningCrescent : mdiWhiteBalanceSunny)" :size="20" />
                        </button>
                        <!-- User initials dropdown -->
                        <div class="hidden sm:flex items-center gap-2 pl-2 border-l border-slate-200 dark:border-slate-700">
                            <BreezeDropdown align="right" width="48">
                                <template #trigger>
                                    <button class="w-8 h-8 rounded-full bg-indigo-100 dark:bg-indigo-900/50 text-indigo-700 dark:text-indigo-400 flex items-center justify-center font-bold text-xs uppercase select-none hover:ring-2 hover:ring-indigo-500/20 dark:hover:ring-indigo-400/20 transition-all focus:outline-none cursor-pointer">
                                        {{ $page.props.auth.user.name.substring(0, 2) }}
                                    </button>
                                </template>
                                <template #content>
                                    <div class="p-3 border-b border-slate-100 dark:border-slate-700">
                                        <h5 class="text-xs font-semibold text-slate-800 dark:text-white truncate uppercase">{{ $page.props.auth.user.name }}</h5>
                                        <span class="text-[10px] text-slate-400 dark:text-slate-500 block truncate">Rol: {{ $page.props.auth.user.rol_type }}</span>
                                    </div>
                                    <BreezeDropdownLink :href="route('perfil')" as="button">
                                        <span class="flex items-center gap-2">
                                            <Icon icon="tabler:user" class="w-4 h-4" />
                                            Mi Perfil
                                        </span>
                                    </BreezeDropdownLink>
                                    <BreezeDropdownLink :href="route('help')" method="get" as="button">
                                        <span class="flex items-center gap-2">
                                            <Icon icon="tabler:help" class="w-4 h-4" />
                                            Ayuda {{ confGlobal.value.UNENSEDU_VERSION }}
                                        </span>
                                    </BreezeDropdownLink>
                                    <BreezeDropdownLink :href="route('logout')" method="post" as="button">
                                        <span class="flex items-center gap-2 text-rose-600">
                                            <Icon icon="tabler:logout" class="w-4 h-4" />
                                            Salir
                                        </span>
                                    </BreezeDropdownLink>
                                </template>
                            </BreezeDropdown>
                        </div>

                    </div>
                </header>

                <!-- PAGE HEADER / SUBHEADER (slots.header) -->
                <header v-if="$slots.header" class="bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700 py-6 px-6 lg:px-8 shadow-sm">
                    <slot name="header" />
                </header>

                <!-- PAGE MAIN CONTENT -->
                <main class="flex-1 p-4 md:p-6 lg:p-8">
                    <UnensAlert />

                    <!-- Error PP (Service Suspended Screen) -->
                    <div v-if="confGlobal.value.SHOW_ERROR_PP == 1 && $page.props.auth.user.id_rol > 1" class="mx-auto min-w-full">
                        <div class="relative md:h-[calc(100vh_-_180px)] h-[calc(100vh_-_140px)] flex flex-col items-center justify-center text-center text-white py-6 px-4 bg-slate-800 rounded-2xl overflow-hidden shadow-xl border border-slate-700">
                            <div class="absolute inset-0 w-full h-full overflow-hidden opacity-40">
                                <video class="min-w-full min-h-full absolute object-cover" src="/video/errorpp1301.mp4" type="video/mp4" autoplay muted loop></video>
                            </div>
                            <div class="z-20 max-w-2xl bg-slate-900/80 backdrop-blur-md p-8 rounded-2xl border border-slate-700/50 shadow-2xl">
                                <div class="flex flex-col gap-4">
                                    <div class="w-16 h-16 bg-rose-500/10 border border-rose-500 rounded-full flex items-center justify-center mx-auto mb-2 animate-bounce">
                                        <Icon icon="tabler:alert-triangle" class="w-8 h-8 text-rose-500" />
                                    </div>
                                    <h1 class="font-extrabold text-4xl md:text-5xl text-white tracking-tight">ERROR PP 1301</h1>

                                    <template v-if="$page.props.auth.user.id_rol <= 5">
                                        <h3 class="font-bold text-xl md:text-2xl text-rose-400">SERVICIO SUSPENDIDO POR FALTA DE PAGO</h3>
                                        <p class="text-slate-300 leading-relaxed text-sm md:text-base mt-2">
                                            Por favor, envíe la constancia de pago correspondiente a: <br />
                                            <a :href="'mailto:' + confGlobal.value.MAIN_COBRANZA_AGENTE_EMAIL" class="font-bold text-indigo-400 hover:underline inline-flex items-center gap-1 justify-center mt-1">
                                                <Icon icon="tabler:mail" class="w-4 h-4" />
                                                {{ confGlobal.value.MAIN_COBRANZA_AGENTE_EMAIL }}
                                            </a>
                                        </p>
                                        <p class="text-slate-300 text-sm md:text-base mt-2">
                                            O escríbanos al WhatsApp para una pronta solución: <br />
                                            <a :href="'https://wa.me/+51' + confGlobal.value.MAIN_COBRANZA_AGENTE_WHATSAPP + '?text=Hola'" target="_blank" class="font-bold text-emerald-400 hover:underline inline-flex items-center gap-1 justify-center mt-1">
                                                <Icon icon="tabler:brand-whatsapp" class="w-5 h-5" />
                                                {{ confGlobal.value.MAIN_COBRANZA_AGENTE_WHATSAPP }}
                                            </a>
                                        </p>
                                    </template>

                                    <template v-else>
                                        <h3 class="font-bold text-xl md:text-2xl text-rose-400">PERMISSIONS ERROR</h3>
                                        <p class="text-slate-300 text-sm md:text-base">
                                            Consulte con su coordinador o supervisor académico para más detalles.
                                        </p>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <slot v-else />
                </main>

            </div>

        </div>

        <!-- MOBILE DRAWER / SIDEBAR (lg:hidden) -->
        <Transition name="fade">
            <div v-if="showingNavigationDropdown" @click="showingNavigationDropdown = false" class="lg:hidden fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm">
            </div>
        </Transition>

        <Transition name="slide-right">
            <aside v-if="showingNavigationDropdown" class="lg:hidden fixed top-0 left-0 bottom-0 z-50 w-72 bg-white dark:bg-slate-800 border-r border-slate-200 dark:border-slate-700 shadow-2xl flex flex-col h-full">

                <!-- Mobile Drawer Header -->
                <div class="p-6 border-b border-slate-100 dark:border-slate-700 flex items-center justify-between gap-3">
                    <div class="flex items-center gap-3">
                        <BreezeApplicationLogo class="h-9 w-auto" />
                        <div>
                            <span class="text-[10px] text-slate-400 font-medium block uppercase tracking-wider">Sede</span>
                            <h4 class="text-slate-900 dark:text-white text-md font-bold truncate max-w-[120px]">
                                {{ confGlobal.value.UNENS_SEDE_NOMBRE }}
                            </h4>
                        </div>
                    </div>
                    <button @click="showingNavigationDropdown = false" class="p-1.5 rounded-lg text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors">
                        <Icon icon="tabler:x" class="w-5 h-5" />
                    </button>
                </div>

                <!-- Mobile Drawer Navigation -->
                <nav class="flex-1 overflow-y-auto p-4 space-y-1.5 custom-scrollbar">
                    <!-- Main Modules -->
                    <Link :href="route('dashboard')" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('dashboard*')
                        ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                        : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                        <Icon icon="tabler:smart-home" class="w-5 h-5 shrink-0" />
                        <span>Inicio</span>
                    </Link>

                    <!-- ========================================================================= -->
                    <!-- VISTA EXCLUSIVA: PORTAL DE ESTUDIANTES Y APODERADOS (Roles 8 y 9)         -->
                    <!-- ========================================================================= -->
                    <template v-if="$page.props.auth.user.id_rol == 8 || $page.props.auth.user.id_rol == 9">
                        <Link v-if="$page.props.auth.user.has_classroom" :href="route('student-courses')" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('student-courses*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:book-2" class="w-5 h-5 shrink-0" />
                            <span>Cursos</span>
                        </Link>

                        <Link v-if="$page.props.auth.user.has_independent_courses" :href="route('student.independent-courses')" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('student.independent-courses*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:certificate" class="w-5 h-5 shrink-0" />
                            <span>Cursos de Formación</span>
                        </Link>

                        <Link :href="route('student-agenda')" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('student-agenda*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:calendar" class="w-5 h-5 shrink-0" />
                            <span>Agenda</span>
                        </Link>
                    </template>

                    <!-- ========================================================================= -->
                    <!-- VISTA DE COLABORADORES Y ADMINISTRATIVOS (Gestión basada en Rights)       -->
                    <!-- ========================================================================= -->
                    <template v-else>
                        <!-- Aulas -->
                        <Link v-if="hasRight('global', 'classroom') || $page.props.auth.user.id_rol <= 6 || $page.props.auth.user.id_rol == 7 || $page.props.auth.user.id_rol == 11 || $page.props.auth.user.id_rol == 12" :href="route('classrooms-collaborator')" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('classroom*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:chalkboard" class="w-5 h-5 shrink-0" />
                            <span>Aulas</span>
                        </Link>

                        <!-- Cursos de Formación -->
                        <Link v-if="hasRight('global', 'formationcourses') && hasRight('cursolibre', 'read')" :href="route('independent-courses.index')" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('independent-courses.index*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:certificate" class="w-5 h-5 shrink-0" />
                            <span>Cursos de Formación</span>
                        </Link>

                        <!-- Estudiantes -->
                        <Link v-if="hasRight('global', 'students') || $page.props.auth.user.id_rol <= 6" :href="route('student-list')" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('student-*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:users" class="w-5 h-5 shrink-0" />
                            <span>Estudiantes</span>
                        </Link>

                        <!-- Financiera -->
                        <div v-if="hasRight('global', 'financial')" class="space-y-1">
                            <button @click="isFinancieraExpanded = !isFinancieraExpanded" class="w-full flex items-center justify-between px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="(route().current('areaFinanciera*') || route().current('financiera*') || route().current('payementOrder*') || route().current('facture*'))
                                ? 'bg-slate-100 dark:bg-slate-700/70 text-slate-900 dark:text-white font-semibold'
                                : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                                <div class="flex items-center gap-3">
                                    <Icon icon="tabler:wallet" class="w-5 h-5 shrink-0" />
                                    <span>Financiera</span>
                                </div>
                                <Icon :icon="isFinancieraExpanded ? 'tabler:chevron-down' : 'tabler:chevron-right'" class="w-4 h-4 shrink-0" />
                            </button>

                            <div v-show="isFinancieraExpanded" class="pl-6 space-y-1 border-l border-slate-100 dark:border-slate-700 ml-6 mt-1">
                                <Link v-if="hasRight('finanzas', 'read_regular')" :href="route('areaFinanciera')" class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200" :class="route().current('areaFinanciera*') || route().current('payementOrder*') || route().current('facture*')
                                    ? 'text-indigo-600 dark:text-indigo-400 font-semibold'
                                    : 'text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'">
                                    <Icon icon="tabler:school" class="w-4 h-4 shrink-0" />
                                    <span>Ciclo Escolar Regular</span>
                                </Link>

                                <Link v-if="hasRight('finanzas', 'read_formacion') || hasRight('finanzas', 'orders_read')" :href="route('financiera-formacion.index')" class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200" :class="route().current('financiera-formacion*')
                                    ? 'text-indigo-600 dark:text-indigo-400 font-semibold'
                                    : 'text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'">
                                    <Icon icon="tabler:certificate" class="w-4 h-4 shrink-0" />
                                    <span>Cursos de Formación</span>
                                </Link>
                            </div>
                        </div>

                        <!-- RRHH -->
                        <div v-if="hasRight('global', 'rrhh') || hasRight('asistencia', 'marcaciones') || $page.props.auth.user.id_rol <= 6" class="space-y-1">
                            <button @click="isRrhhExpanded = !isRrhhExpanded" class="w-full flex items-center justify-between px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="(route().current('freeday*') || route().current('collaborator*'))
                                ? 'bg-slate-100 dark:bg-slate-700/70 text-slate-900 dark:text-white font-semibold'
                                : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                                <div class="flex items-center gap-3">
                                    <Icon icon="tabler:users-group" class="w-5 h-5 shrink-0" />
                                    <span>RRHH</span>
                                </div>
                                <Icon :icon="isRrhhExpanded ? 'tabler:chevron-down' : 'tabler:chevron-right'" class="w-4 h-4 shrink-0" />
                            </button>

                            <div v-show="isRrhhExpanded" class="pl-6 space-y-1 border-l border-slate-100 dark:border-slate-700 ml-6 mt-1">
                                <Link :href="route('collaborator-list')" class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200" :class="route().current('collaborator-list*')
                                    ? 'text-indigo-600 dark:text-indigo-400 font-semibold'
                                    : 'text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'">
                                    <Icon icon="tabler:user-check" class="w-4 h-4 shrink-0" />
                                    <span>Colaboradores</span>
                                </Link>

                                <Link :href="route('freeday-list')" class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200" :class="route().current('freeday-list*')
                                    ? 'text-indigo-600 dark:text-indigo-400 font-semibold'
                                    : 'text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'">
                                    <Icon icon="tabler:beach" class="w-4 h-4 shrink-0" />
                                    <span>Días Libres</span>
                                </Link>

                                <Link v-if="hasRight('global', 'rrhh') || hasRight('asistencia', 'marcaciones') || $page.props.auth.user.id_rol <= 3" :href="route('collaborator-registroasistencia')" class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200" :class="route().current('collaborator-registroasistencia*')
                                    ? 'text-indigo-600 dark:text-indigo-400 font-semibold'
                                    : 'text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'">
                                    <Icon icon="tabler:clock" class="w-4 h-4 shrink-0" />
                                    <span>Asistencias</span>
                                </Link>
                            </div>
                        </div>

                        <!-- Productos -->
                        <Link v-if="confGlobal.value.PRODUCT_USE_MODULE == 1 && ($page.props.auth.user.id_rol <= 6 || hasRight('global', 'configuration'))" :href="route('product-list')" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('product-*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:package" class="w-5 h-5 shrink-0" />
                            <span>Productos</span>
                        </Link>

                        <!-- Agenda -->
                        <Link v-if="hasRight('global', 'agenda') && ($page.props.auth.user.id_rol != 8 && $page.props.auth.user.id_rol != 9)" :href="route('agenda')" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('agenda*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:calendar-event" class="w-5 h-5 shrink-0" />
                            <span>Agenda</span>
                        </Link>

                        <!-- Documentos -->
                        <Link v-if="hasRight('global', 'documents') || $page.props.auth.user.id_rol <= 5 || $page.props.auth.user.id_rol == 7 || $page.props.auth.user.id_rol == 10 || $page.props.auth.user.id_rol == 11" :href="route('documents')" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('documents*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:files" class="w-5 h-5 shrink-0" />
                            <span>Documentos</span>
                        </Link>

                        <!-- Simulacro -->
                        <Link v-if="hasRight('global', 'simulacroexamen') && hasRight('simulacro', 'read') && confGlobal.value.ACADEMICO_USE_SIMULACRO_ADMISION == 1" :href="route('examenadmision')" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('examenadmision*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:certificate" class="w-5 h-5 shrink-0" />
                            <span>Simulacro Examen Admisión</span>
                        </Link>

                        <!-- Comunicados -->
                        <Link v-if="hasRight('global', 'comunicados') || $page.props.auth.user.id_rol <= 3" :href="route('comunicados-list')" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('comunicados*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:speakerphone" class="w-5 h-5 shrink-0" />
                            <span>Comunicados</span>
                        </Link>

                        <!-- Reportes -->
                        <Link v-if="hasRight('global', 'reports')" :href="route('report')" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('report*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:chart-bar" class="w-5 h-5 shrink-0" />
                            <span>Reportes</span>
                        </Link>

                        <!-- Configuración -->
                        <Link v-if="hasRight('global', 'configuration') || $page.props.auth.user.id_rol <= 6" :href="route('config')" class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200" :class="route().current('config*')
                            ? 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 font-semibold shadow-sm'
                            : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-900 dark:hover:text-white'">
                            <Icon icon="tabler:settings" class="w-5 h-5 shrink-0" />
                            <span>Configuración</span>
                        </Link>
                    </template>
                </nav>

                <!-- Mobile Drawer User Profile -->
                <div class="p-6 border-t border-slate-100 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/30 flex flex-col gap-3">
                    <div class="flex items-center gap-3">
                        <div class="w-10 h-10 rounded-full bg-indigo-500 text-white flex items-center justify-center font-bold text-sm shrink-0 uppercase">
                            {{ $page.props.auth.user.name.substring(0, 2) }}
                        </div>
                        <div class="overflow-hidden">
                            <h5 class="text-sm font-semibold text-slate-800 dark:text-white truncate uppercase">{{ $page.props.auth.user.name }}</h5>
                            <span class="text-xs text-slate-400 dark:text-slate-500 block truncate">Rol: {{ $page.props.auth.user.rol_type }}</span>
                        </div>
                    </div>

                    <div class="grid grid-cols-2 gap-2 mt-2">
                        <Link :href="route('perfil')" class="flex items-center justify-center gap-2 py-2 px-3 border border-slate-200 dark:border-slate-700 rounded-xl text-xs font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors">
                            <Icon icon="tabler:user" class="w-4 h-4" />
                            Mi Perfil
                        </Link>
                        <Link :href="route('logout')" method="post" as="button" class="flex items-center justify-center gap-2 py-2 px-3 border border-rose-200 dark:border-rose-950/30 rounded-xl text-xs font-semibold text-rose-600 dark:text-rose-400 hover:bg-rose-50 dark:hover:bg-rose-950/20 transition-colors">
                            <Icon icon="tabler:logout" class="w-4 h-4" />
                            Salir
                        </Link>
                    </div>
                </div>

            </aside>
        </Transition>

        <!-- Onboarding Tour Overlay -->
        <div v-if="showOnboarding" class="fixed inset-0 z-[98] pointer-events-none transition-all duration-300">
            <!-- Spotlight effect (points to elements) -->
            <div :style="spotlightStyle" class="pointer-events-none border-2 border-indigo-500/50 shadow-[0_0_25px_rgba(99,102,241,0.6)]"></div>
        </div>

        <!-- Onboarding Tour Card -->
        <div v-if="showOnboarding" :style="tooltipStyle" class="bg-white/90 dark:bg-slate-900/95 backdrop-blur-md border border-slate-200/60 dark:border-slate-700/60 shadow-2xl rounded-2xl p-6 pointer-events-auto select-none transition-all duration-300 flex flex-col gap-4">
            <!-- Step Indicator & Skip -->
            <div class="flex items-center justify-between">
                <span class="text-[11px] font-bold px-2.5 py-1 bg-indigo-50 dark:bg-indigo-950/40 text-indigo-600 dark:text-indigo-400 rounded-full border border-indigo-100/50 dark:border-indigo-900/50 tracking-wider uppercase">
                    Paso {{ currentStep }} de {{ onboardingSteps.length }}
                </span>
                <button @click="finishOnboarding" class="text-xs text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 font-semibold transition-colors flex items-center gap-1">
                    Omitir
                </button>
            </div>

            <!-- Title and Content -->
            <div>
                <h3 class="text-base font-extrabold text-slate-800 dark:text-white mb-2 flex items-center gap-2">
                    <span class="w-1.5 h-3 bg-gradient-to-b from-indigo-500 to-indigo-600 rounded-full inline-block"></span>
                    {{ onboardingSteps[currentStep - 1].title }}
                </h3>
                <p class="text-sm text-slate-600 dark:text-slate-300 leading-relaxed">
                    {{ onboardingSteps[currentStep - 1].content }}
                </p>
            </div>

            <!-- Navigation Buttons -->
            <div class="flex items-center justify-between gap-3 mt-2 border-t border-slate-100 dark:border-slate-800 pt-4">
                <button @click="prevStep" :disabled="currentStep === 1" class="px-4 py-2 text-xs font-bold text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl transition-all disabled:opacity-30 disabled:pointer-events-none">
                    Atrás
                </button>
                <button @click="nextStep" class="px-4 py-2 text-xs font-bold text-white bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700 rounded-xl shadow-md hover:shadow-lg transition-all flex items-center gap-1.5 cursor-pointer">
                    {{ currentStep === onboardingSteps.length ? 'Entendido' : 'Siguiente' }}
                    <Icon :icon="currentStep === onboardingSteps.length ? 'tabler:check' : 'tabler:chevron-right'" class="w-4 h-4" />
                </button>
            </div>
        </div>

    </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.slide-right-enter-active,
.slide-right-leave-active {
    transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.slide-right-enter-from,
.slide-right-leave-to {
    transform: translateX(-100%);
}

/* Custom scrollbar */
.custom-scrollbar::-webkit-scrollbar {
    width: 4px;
}

.custom-scrollbar::-webkit-scrollbar-track {
    background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
    background: rgba(156, 163, 175, 0.3);
    border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: rgba(156, 163, 175, 0.5);
}
</style>
